<div class="grid-wrapper">
  <kendo-grid
    class="k-Grid"
    [data]="gridDefinition.gridData"
    [resizable]="true"
    [pageSize]="gridDefinition.state.take"
    [skip]="gridDefinition.state.skip"
    [pageable]="true"
    [sort]="gridDefinition.state.sort"
    [sortable]="{
      allowUnsort: true,
      mode: 'multiple'
    }"
    [filter]="gridDefinition.state.filter"
    filterable="menu"
    [kendoGridSelectBy]=""
    [selectedKeys]="currentSelected"
    (dataStateChange)="dataStateChange($event)"
    (selectionChange)="selectionChangeEvent($event)"
    [selectable]="gridDefinition.selectableSettings"

  >
    <kendo-grid-column field="Id" title="Id" [hidden]="true" width="200">
    </kendo-grid-column>
    <kendo-grid-column
      *ngFor="let columnProperties of gridDefinition.columns"
      field="{{columnProperties.PropertyName}}"
      title="{{ columnProperties.Header }}"
      width="{{columnProperties.Width || 200}}"
      [filterable]=columnProperties.IsFilterable
    >
      <div [ngSwitch]="columnProperties.GridDisplayType">
        <!-- PICKLIST -->
        <div *ngSwitchCase="GridDisplayType[GridDisplayType.PickList]">
          <ng-template
            kendoGridFilterMenuTemplate
            let-column
            let-filter
            let-filterService
          >
            <app-filter-menu
              [column]="columnProperties"
              [filter]="filter"
              [filterService]="aFilterService"
              (filterChange)="updateFilter($event, aFilterService)"
              [picklistProperties]="picklists[columnProperties.PropertyName]"
              [project]="gridDefinition.project"
            >
            </app-filter-menu>
          </ng-template>
          <ng-template kendoGridHeaderTemplate let-column>
            {{ column.title }}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-column>
            {{ dataItem[columnProperties.PropertyName] }}
          </ng-template>
        </div>
        <!-- Number -->
        <div *ngSwitchCase="GridDisplayType[GridDisplayType.Number]">
          <ng-template
            kendoGridFilterMenuTemplate
            let-column="column"
            let-filter="filter"
            let-filterService="aFilterService"
          >
            <kendo-grid-numeric-filter-menu
              [column]="column"
              [filter]="filter"
              [filterService]="aFilterService"
            >
            </kendo-grid-numeric-filter-menu>
          </ng-template>
          <ng-template kendoGridHeaderTemplate let-column>
            {{ column.title }}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-column>
            {{ dataItem[columnProperties.PropertyName] }}
          </ng-template>
        </div>
        <!-- DateTime -->
        <div *ngSwitchCase="GridDisplayType[GridDisplayType.DateTime]">
          <ng-template
            kendoGridFilterMenuTemplate
            let-column="column"
            let-filter="filter"
            let-filterService="aFilterService"
          >

            <kendo-grid-date-filter-menu
              [column]="column"
              [filter]="filter"
              [filterService]="aFilterService"
              [format]=""
            >
            </kendo-grid-date-filter-menu>
          </ng-template>
          <ng-template kendoGridHeaderTemplate let-column>
            {{ column.title }}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-column>
            {{ dataItem[columnProperties.PropertyName] | toDate | localeDate }}
          </ng-template>
        </div>
        <div *ngSwitchCase="GridDisplayType[GridDisplayType.Date]">
          <ng-template
            kendoGridFilterMenuTemplate
            let-column="column"
            let-filter="filter"
            let-filterService="aFilterService"
          >
            <kendo-grid-date-filter-menu
              [column]="column"
              [filter]="filter"
              [filterService]="aFilterService"

            >
            </kendo-grid-date-filter-menu>
          </ng-template>
          <ng-template kendoGridHeaderTemplate let-column>
            {{ column.title }}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-column>
            {{ dataItem[columnProperties.PropertyName] | toDate | localeDate }}
          </ng-template>
        </div>
        <!-- Boolean -->
        <div *ngSwitchCase="GridDisplayType[GridDisplayType.Boolean]">
          <ng-template
            kendoGridFilterMenuTemplate
            let-column="column"
            let-filter="filter"
            let-filterService="aFilterService"
          >
            <kendo-grid-boolean-filter-menu
              [column]="column"
              [filter]="filter"
              [filterService]="aFilterService"
            >
            </kendo-grid-boolean-filter-menu>
          </ng-template>
          <ng-template kendoGridHeaderTemplate let-column>
            {{ column.title }}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-column>
            {{ dataItem[columnProperties.PropertyName] }}
          </ng-template>
        </div>
        <!-- Used if there is a documents column -->
        <div *ngSwitchCase="GridDisplayType[GridDisplayType.Document]">

          <ng-template kendoGridHeaderTemplate let-column>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-column>
            <div *ngIf="dataItem[columnProperties.PropertyName]" class="document-image"></div>
          </ng-template>
        </div>
        <!-- Used for Bytes -->
        <div *ngSwitchCase="GridDisplayType[GridDisplayType.Bytes]">
          <ng-template
            kendoGridFilterMenuTemplate
            let-column="column"
            let-filter="filter"
            let-filterService="aFilterService"
          >
            <kendo-grid-numeric-filter-menu
              [column]="column"
              [filter]="filter"
              [filterService]="aFilterService"
            >
            </kendo-grid-numeric-filter-menu>
          </ng-template>
          <ng-template kendoGridHeaderTemplate let-column>
            {{ column.title }}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-column>
            {{ dataItem[columnProperties.PropertyName] | bytesToMbytes}}
          </ng-template>
        </div>
        <!-- Default to string if nothing matches -->
        <div *ngSwitchDefault>
          <ng-template
            kendoGridFilterMenuTemplate
            let-column="column"
            let-filter="filter"
            let-filterService="aFilterService"
          >
            <kendo-grid-string-filter-menu
              [column]="column"
              [filter]="filter"
              [filterService]="aFilterService"
            >
              <!-- (filterChange)="updateFilter($event, filterService)" -->
            </kendo-grid-string-filter-menu>
          </ng-template>
          <ng-template kendoGridHeaderTemplate let-column>
            {{ column.title }}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-column>
            {{ dataItem[columnProperties.PropertyName] }}
          </ng-template>
        </div>
      </div>
    </kendo-grid-column>
    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="10"></kendo-pager-numeric-buttons>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <div class="keynetix-page-info">{{getPageInfoText(currentPage, totalPages)}}</div>
      <!-- <kendo-pager-info></kendo-pager-info> -->
   </ng-template>
  </kendo-grid>
  <app-default-loading-icon *ngIf="gridDefinition.isLoading"></app-default-loading-icon>
</div>
